// Data
import demotypes from "~/data/demotypes.json";

// Deps
import { selectStyles } from "~/styleguide/forms";
import { createComponent } from "react-fela";

// Components
import MultiSelect from "~/components/shared/form/multi-select";

// Grab types with more than one published resource
const options = demotypes
    .map(demotype => {
        return { value: demotype.id, label: demotype.name, count: demotype.count };
    })
    .filter(({ count }) => count && count > 0);

export default function DemoTypesFilter({ handleDemoTypesChange, selected }) {
    // Can't filter by types if there are none
    if (!demotypes || !demotypes.length) return null;

    return (
        <Container>
            <p style={{ fontSize: "14px", marginBottom: "12px" }}>
                Roles
            </p>

            <MultiSelect
                options={options}
                onChange={handleDemoTypesChange}
                selected={selected}
                type="Types"
            />
        </Container>
    );
}

const Container = createComponent(() => ({
    ...selectStyles
}));
